"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(require("lodash/get"));
var authorizationServiceMinimal_1 = require("./authorizationServiceMinimal");
var errorUtilities_1 = require("../utilities/errorUtilities");
exports.default = {
    handle: function (err) {
        return new Promise(function (_resolve, reject) {
            var bypass = get_1.default(err, 'config.bypassGlobalErrorHandler', false);
            var statusCode = get_1.default(err, 'response.status', -1);
            if (!bypass && [400, 401, 403, 404].includes(statusCode)) {
                if (!authorizationServiceMinimal_1.hasValidToken()) {
                    window.location.href = window.location.protocol + "//" + window.location.host;
                }
                else if (statusCode === 404) {
                    window.location.href = '/notfound';
                }
                else if (statusCode === 403) {
                    window.location.href = '/unauthorized';
                }
                else if (statusCode === 401) {
                    window.location.href = '/unauthenticated';
                }
                else if (statusCode === 400) {
                    err = errorUtilities_1.getContentErrorType(err) || err;
                }
            }
            return reject(err);
        });
    },
};
